import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

/* Dialogs */
import ReturnGreaterThan15OverlayDialog from '../../dialogs/returnGreaterThan15OverlayDialog';
import RequestReturnOnlyAccessoriesSelectedOverlayDialog from '../../dialogs/requestReturnOnlyAccessoriesSelectedOverlayDialog';

/* Actions */
import {
	setRequestReturnDetails,
	savePreviousReturnAndCreditDetails,
	dropProductSpecsEmail,
	saveRequestReturnPimData,
} from '../../../redux/actions';

class RequestReturnStep1 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showConfirmationMessage: false,
			errorMessage: '',
			olderThanInvoiceAgeMessage: 'This request is older than allowed by the Return and Scrap Policy.',
			showOlderThanInvoiceMessage: false,
			showLineLevelOlderThanInvoiceIndex: -1,
			invoiceAgeState : '',
			showReturnGreaterThan15OverlayDialog: false,
			requestReturnDetails: null,

			showRequestReturnOnlyAccessoriesSelectedOverlayDialog: false,

			showForm: false,
			customerServiceForm: {
				param: {
					account: '',
					msNumber: '',
					poNumber: '',
					invoice: '',
					item: '',
					serial: '',
					returnReason: '',
					address: '',
					contactInfo: '',
					pickUpInfo: ''
				},
				error: {
					accountError: '',
					msNumberError: '',
					poNumberError: '',
					invoiceError: '',
					itemError: '',
					serialError: '',
					returnReasonError: '',
					addressError: '',
					contactInfoError: '',
					pickUpInfoError: ''
				}
			},
			returnTypeDropdownValues: [],
		};
		this.handleDialog = this.handleDialog.bind(this);
	}
	componentWillMount() {
		const {
			firstName,
			lastName,
			email,
			typeOfUser
		} = this.props.user.userDetails;
		const { returnTypeDropdownValues } = this.props.order;
		let options = [];
		returnTypeDropdownValues.forEach(item => {
			options = options.concat(item.values);
		});
		this.setState({
			customerServiceForm: {
				...this.state.customerServiceForm,
				param: {
					...this.state.customerServiceForm.param,
					account: this.props.getSelectedAccountNumber(),
					contactInfo: `${firstName} - ${lastName}, ${email}`,
					loggedInUserEmail: email,
					userType: typeOfUser,
				}
			},
			returnTypeDropdownValues: options,
		});
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		// Redirect to request return page if there is no data in store, it means page is refreshed
		if(!self.props.order.requestReturnDetails) {
			browserHistory.push("/requestreturn");
		} else {
			const relationShipTypes = self.props.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
			const invoice = self.props.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
			const defaultInvoice = self.props.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
			const invoiceAge = invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
			const { invoiceDate } = self.props.order.requestReturnDetails.responseObject;
			let { requestReturnDetails } = self.props.order;
			const items = [];
			requestReturnDetails.responseObject.items.forEach(item => {
				if(item.lineStatus.toUpperCase() !== 'CANCELLED' && self.props.getItemTypeByName(item.item) !== 'S' && (item.lineType === "Standard Line" || item.lineType === "Bill Only Line"))
					items.push(item);
			})
			requestReturnDetails.responseObject.items = items;
			self.setState({
				requestReturnDetails,
				invoiceAgeState: invoiceAge
			}, () => {
				if(invoiceDate && moment(invoiceDate).isBefore(moment().subtract(invoiceAge, 'days'), 'day')) {
					self.setState({
						showOlderThanInvoiceMessage: true
					});
				}
			});
		}
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleSelectProduct(indexx, event) {
		const self = this;
		let { requestReturnDetails } = self.state;
		const { typeOfUser } = self.props.user.userDetails;
		requestReturnDetails.responseObject.items.forEach((item, index) => {
			if(index === indexx) {
				if(item.invoiceDate && moment(item.invoiceDate).isBefore(moment().subtract(self.state.invoiceAgeState, 'days'), 'day')){
					self.setState({
						showLineLevelOlderThanInvoiceIndex : indexx
					});
					if(typeOfUser ==='employee') {
						item.selected = event.target.checked;
						item.returnQuantity = 1;
					}
				} else {
					item.selected = event.target.checked;
					item.returnQuantity = 1;
				}
				
			}
		});
		self.setState({
			errorMessage: "",
			requestReturnDetails
		})
		// self.props.setRequestReturnDetails(requestReturnDetails);
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		this.setState({
			[formName]: {
				param: {
					...this.state[formName].param,
					[event.target.name]: event.target.value
				},
				error
			},
		});
	}

	handleSelectQuantity(indexx, event) {
		const self = this;
		let { requestReturnDetails } = self.state;
		requestReturnDetails.responseObject.items.forEach((item, index) => {
			if(index === indexx) {
				item.returnQuantity = event.target.value
			}
		});
		self.setState({
			requestReturnDetails
		})
		// self.props.setRequestReturnDetails(requestReturnDetails);
	}

	handleCancel() {
		browserHistory.push("/requestreturn");
	}

	handleContinue() {
		const self = this;
		const { requestReturnDetails } = self.state;
		const selectedItems = _.filter(requestReturnDetails.responseObject.items, {selected: true});
		const selectedFlag = selectedItems.length > 0 ? true : false;
		if(!selectedFlag) {
			self.setState({
				errorMessage: "Please select at least one product."
			});
		} else {
			const returnQuantity = _.sumBy(selectedItems, itm => parseInt(itm.returnQuantity, 10));
			if(returnQuantity > 15) {
				self.handleDialog('ReturnGreaterThan15OverlayDialog', true, null);
			} else {
				self.ifAllSelectedAccessories((accessories) => {
					if(accessories.length === selectedItems.length) {
						self.handleDialog("RequestReturnOnlyAccessoriesSelectedOverlayDialog", true);
					} else {
						self.callBackContinue();
					}
				});
			}
		}
	}

	ifAllSelectedAccessories(callback) {
		const self = this;
		const requestReturnDetails = JSON.parse(JSON.stringify(self.state.requestReturnDetails));
		requestReturnDetails.responseObject.items = requestReturnDetails.responseObject.items.filter(itm => itm.selected);
		self.props.getItemTypeByOrderDetails(requestReturnDetails.responseObject, resp => {
			if(!resp.status) {
				self.setState({
					errorMessage: resp.responseMessage
				})
			} else {
				self.props.saveRequestReturnPimData(resp.pimData);
				const orderDetails = resp.orderDetails;
				const accessories = orderDetails && orderDetails.items && orderDetails.items.filter(itm => itm.itemType === 'A');
				callback && callback(accessories);
			}
		});
	}

	callBackContinue() {
		const self = this;
		const { requestReturnDetails } = self.state;
		const items = [];
		requestReturnDetails.responseObject.items.forEach(itm => {
			items.push({
				...itm,
				originalSerialNumbers: itm.bkpOriginalSerialNumber,
				serialNumber: '',
			});
		});
		self.props.setRequestReturnDetails({
			responseObject: {
				...requestReturnDetails.responseObject,
				items,
				originalOrderNumber: requestReturnDetails.responseObject.orderNumber,
				shippingMethod: requestReturnDetails.responseObject.deliveryMethod,
				deliveryInstructions: "",
				requestedDeliveryDate: ""
			}
		});
		browserHistory.push("/requestreturnstep2");
	}

	handleReturnLinesDetails(returnLines, orderNumber, event) {
		event && event.preventDefault();
		const self = this;
		self.props.savePreviousReturnAndCreditDetails({
			orderNumber,
			returnLines
		});
		browserHistory.push("/previousreturnandcredit");
	}

	handleClickHere(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			showForm: true
		}, () => {
			self.handleDialog('ReturnGreaterThan15OverlayDialog', false, null);
		});
	}

	handleSubmitCustomerServiceRequest(event) {
		event.preventDefault();
		let self = this,
			params = self.state.customerServiceForm.param,
			error = self.state.customerServiceForm.error,
			formError = false;

		//Reset all errors
		for(var key in error) {
            if(params[key.replace("Error","")] === "") {
                error[key] = 'error';
                formError = true;
            } else {
				error[key] = '';
			}
        }

		self.setState({
			customerServiceForm: {
				...self.state.customerServiceForm,
				param: params,
				error: error
			},
			errorMessage: '',
			showConfirmationMessage: false,
		}, () => {
			if(!formError) {
				const payload = self.state.customerServiceForm.param;
				self.props.dropProductSpecsEmail(payload, "emailType=requestReturn", response => {
					if(response.status) {
						self.setState({
							showConfirmationMessage: true
						});
					} else {
						self.setState({
							errorMessage: 'Error in sending email. Please contact customer service.'
						});
					}
				});
			}
		});
	}

	showForm(flag, event) {
		event.preventDefault();
		this.setState({
			errorMessage: '',
			showForm: flag
		})
	}

	isItemReturnable(item) {
		const self = this,
			returnableLineStatus = ['closed', 'awaiting fulfillment', 'awaiting receipt', 'picked', 'shipped'];
		if(returnableLineStatus.indexOf(item.lineStatus.toLowerCase()) !== -1 &&
			(item.lineType.toLowerCase() === 'standard line' || item.lineType.toLowerCase() === 'bill only line') &&
			self.props.checkItemIsServiceOrNot(item.item) === 'product'
		) {
			return true;
		}

		return false;
	}

	manipulateClipBoardOfPONumber(event) {
		this.props.manipulateClipBoardOfPONumber((e) => {
			this.updateParams('customerServiceForm', e);
		}, undefined, undefined, event);
	}

    render() {
		const self = this;
		const orderDetails = this.state.requestReturnDetails && this.state.requestReturnDetails.responseObject;
		const { typeOfUser } = self.props.user.userDetails;
		
        return (
			<div>
		          <div className="push m-3">
		        	<h1 className="pageTitle">Request Return</h1>
		        </div>
		        {!this.state.showForm && <div className="push m-3">
					{orderDetails && !orderDetails.isValidBillTo && <p className="bold red">Due to a change in the Billing party/address on this account, this return will need to be requested by the ASM through CREST and processed manually.</p>}
					<p className="bold red">{this.state.errorMessage}</p>
					{this.state.showOlderThanInvoiceMessage && <p className="bold red">
						{this.state.olderThanInvoiceAgeMessage}
					</p>}
					<div className="captionAboveTable">
						<div className="columns">
							<div className="column column1">
								<b>CSO (Order number): {orderDetails && orderDetails.orderNumber}</b>
							</div>
							<div className="column column1">
								<b>Order Date: {orderDetails && orderDetails.orderDate && this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}</b>
							</div>
							<div className="column column1">
								<b>P.O. # {orderDetails && orderDetails.poNumber}</b>
							</div>
						</div>
					</div>
					<table className="dataTable returnProductsOrderListTable d-none d-sm-block">
						<thead>
							<tr>
								<th className="select">Select</th>
								<th className="product">Product</th>
								<th>Previous Returns/<br />Credits</th>
								<th className="quantityOrdered">Quantity<br />Ordered</th>
								<th className="quantityToReturn">Quantity<br />To Return</th>
								<th className="invoiceNumber">Invoice #</th>
								<th className="invoiceDate">Invoice Date</th>
							</tr>
						</thead>
						<tbody>
							{orderDetails && orderDetails.items.map((item, index) => {
								if(!self.isItemReturnable(item)) return null;
								let alreadyReturnedQuantity = 0,
									availableQuantity = parseInt(item.quantity, 10);
								const returnLines = item.returnLines && item.returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line');
								if(returnLines && returnLines.length > 0) {
									alreadyReturnedQuantity = _.sumBy(returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line'), 'authorizedQty');
								}
								availableQuantity -= alreadyReturnedQuantity;
								
								return <tr key={index}>
									<td className="select">
										<input type="checkbox" disabled={!orderDetails.isValidBillTo || (alreadyReturnedQuantity < parseInt(item.quantity, 10) ? false : true)} onChange={this.handleSelectProduct.bind(this, index)} name="myQuantOrderReturn"  defaultChecked={item.selected}/>
									</td>
									<td className="product">{item.internalItem} {self.state.showLineLevelOlderThanInvoiceIndex == index ? <div className="bold red">{this.state.olderThanInvoiceAgeMessage}</div>: ""}</td>
									<td>{returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderDetails.orderNumber)}>Click here</a>}</td>
									<td className="quantityOrdered">{item.quantity}</td>
									<td className="quantityToReturn">
										{item.selected && (self.state.showLineLevelOlderThanInvoiceIndex !== index || typeOfUser ==='employee')
											?<select onChange={this.handleSelectQuantity.bind(this, index)} name="returnQuantity" style={{width: 60}} defaultValue={item.returnQuantity}>
												{_.times(availableQuantity, (indx) => {
													return <option key={indx} value={indx+1}>{indx+1}</option>
												})}
											</select>
											:<input type="text" name="quantityToReturnFake" value="" style={{width: 60, display: 'inline-block'}} disabled />
										}
									</td>
									<td className="invoiceNumber">{item.invoiceNumber}</td>
									<td className="invoiceDate">{item.invoiceDate? moment(item.invoiceDate).format('MM/DD/YYYY'):''}</td>
								</tr>
							})}
						</tbody>
					</table>
					{orderDetails && orderDetails.items.map((item, index) => {
								if(!self.isItemReturnable(item)) return null;
								let alreadyReturnedQuantity = 0,
									availableQuantity = parseInt(item.quantity, 10);
								const returnLines = item.returnLines && item.returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line');
								if(returnLines && returnLines.length > 0) {
									alreadyReturnedQuantity = _.sumBy(returnLines.filter(itm => itm.lineType.toLowerCase() !== 'bill only line'), 'authorizedQty');
								}
								availableQuantity -= alreadyReturnedQuantity;

								return <div className="accordion accordion-borderless d-block d-sm-none" id={`accordionRequestReturnStep1${index}`}  key={index}>
								<div>
									<h2 className="accordion-header" id={`flush-RequestReturnStep1${index}`}>
									<button className="accordion-button collapsed mobileAccButton " type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOneRequestReturnStep1${index}`} aria-expanded="false" aria-controls={`flush-collapseOneRequestReturnStep1${index}`}>
												<div className="select">
													<input type="checkbox" disabled={!orderDetails.isValidBillTo || (alreadyReturnedQuantity < parseInt(item.quantity, 10) ? false : true)} onChange={this.handleSelectProduct.bind(this, index)} name="myQuantOrderReturn"  defaultChecked={item.selected}/>
												</div>
												 {<div className="product" style={{paddingLeft:"1rem"}}>{item.internalItem} {self.state.showLineLevelOlderThanInvoiceIndex == index ? <p className="bold red">{this.state.olderThanInvoiceAgeMessage}</p>: ""}</div>}
											</button>
											</h2>
											<div id={`flush-collapseOneRequestReturnStep1${index}`} className="accordion-collapse collapse" aria-labelledby={`flush-RequestReturnStep1${index}`} data-bs-parent={`#accordionRequestReturnStep1${index}`}>
													<table className='orderTable'>
														<tbody>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>Previous Returns/<br />Credits</td>
																<td className="invoiceNumber">{returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderDetails.orderNumber)}>Click here</a>}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>Quantity<br />Ordered</td>
																<td className="quantityOrdered">{item.quantity}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>Quantity<br />To Return</td>
																<td className="quantityToReturn">{item.selected && (self.state.showLineLevelOlderThanInvoiceIndex !== index || typeOfUser ==='employee')
																	?<select onChange={this.handleSelectQuantity.bind(this, index)} name="returnQuantity" style={{width: 60}} defaultValue={item.returnQuantity}>
																		{_.times(availableQuantity, (indx) => {
																			return <option key={indx} value={indx+1}>{indx+1}</option>
																		})}
																	</select>
																	:<input type="text" name="quantityToReturnFake" value="" style={{width: 60, display: 'inline-block'}} disabled />
																}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>Invoice #</td>
																<td className="invoiceNumber">{item.invoiceNumber}</td>
															</tr>
															<tr>
																<td className='p-3 fw-bold'>Invoice Date</td>
																<td className="invoiceDate">{item.invoiceDate? moment(item.invoiceDate).format('MM/DD/YYYY'):''}</td>
															</tr>
														</tbody>
													</table>
											</div>
										</div>
									</div>
					})}
					<p className="floatLeft">
						<button id="cancelButton" onClick={this.handleCancel.bind(this)}>Cancel</button>
					</p>
					{orderDetails && orderDetails.isValidBillTo && !(self.state.showOlderThanInvoiceMessage && typeOfUser === "customer" ) &&<p className="floatRight">
						<button id="continueButton" onClick={this.handleContinue.bind(this)}>Continue</button>
					</p>}
				</div>}
				{this.state.showForm && <div>
					{this.state.showConfirmationMessage
						? <p className="red">Your request has been submitted and will be reviewed by customer service.</p>
						: <form onSubmit={this.handleSubmitCustomerServiceRequest.bind(this)}>
							<p className="bold">Please provide the information below.  Customer service will contact you with updates on your request.</p>
							<p className="bold red">{this.state.errorMessage}</p>
							<table className="formTableTypeA">
								<tbody>
									<tr>
										<td>Account:</td>
										<td>
											<input className={"halfWidth " + this.state.customerServiceForm.error.accountError} value={this.state.customerServiceForm.param.account} onChange={this.updateParams.bind(this, 'customerServiceForm')} type="text" name="account" />
										</td>
									</tr>
									<tr>
										<td>CSO (Order number):</td>
										<td>
											<input className={"halfWidth " + this.state.customerServiceForm.error.msNumberError} onChange={this.updateParams.bind(this, 'customerServiceForm')} type="text" name="msNumber" />
										</td>
									</tr>
									<tr>
										<td>PO# / Debit Memo:</td>
										<td>
											<input onPaste={this.manipulateClipBoardOfPONumber.bind(this)} className={"halfWidth " + this.state.customerServiceForm.error.poNumberError} onChange={this.updateParams.bind(this, 'customerServiceForm')} type="text" name="poNumber" maxLength={50} />
										</td>
									</tr>
									<tr>
										<td>Invoice#:</td>
										<td>
											<input className={"halfWidth " + this.state.customerServiceForm.error.invoiceError} onChange={this.updateParams.bind(this, 'customerServiceForm')} type="text" name="invoice" />
										</td>
									</tr>
									<tr>
										<td>Model:</td>
										<td>
											<textarea name="item" className={"halfWidth " + this.state.customerServiceForm.error.itemError} onChange={this.updateParams.bind(this, 'customerServiceForm')} rows={6} cols={40} />
										</td>
									</tr>
									<tr>
										<td>Serial#:</td>
										<td>
											<textarea name="serial" className={"halfWidth " + this.state.customerServiceForm.error.serialError} onChange={this.updateParams.bind(this, 'customerServiceForm')} rows={6} cols={40} />
										</td>
									</tr>
									<tr>
										<td>Reason for Return:</td>
										<td>
											<select className={"halfWidth " + this.state.customerServiceForm.error.returnReasonError} value={ this.state.customerServiceForm.param.returnReason } onChange={this.updateParams.bind(this, 'customerServiceForm')} name="returnReason">
												<option value="">Select</option>
												{this.state.returnTypeDropdownValues.map((it, ind) => {
													return <option key={ind} value={it.label+"|"+it.value}>{it.label}</option>
												})}
											</select>
										</td>
									</tr>
									<tr>
										<td>Item is currently located at this address:</td>
										<td>
											<textarea name="address" className={"halfWidth " + this.state.customerServiceForm.error.addressError} onChange={this.updateParams.bind(this, 'customerServiceForm')} rows={4} cols={40} />
										</td>
									</tr>
									<tr>
										<td>Name and Email or Phone Number of requester:</td>
										<td>
											<textarea rows={6} cols={40} value={this.state.customerServiceForm.param.contactInfo} className={"halfWidth " + this.state.customerServiceForm.error.contactInfoError} onChange={this.updateParams.bind(this, 'customerServiceForm')} name="contactInfo" />
										</td>
									</tr>
									<tr>
										<td>Name and Phone Number of Contact for pick-up:</td>
										<td>
											<textarea rows={6} cols={40} className={"halfWidth " + this.state.customerServiceForm.error.pickUpInfoError} onChange={this.updateParams.bind(this, 'customerServiceForm')} name="pickUpInfo" />
										</td>
									</tr>
									<tr>
										<td></td>
										<td>
											<div className="clear" />
											<div className="halfWidth">
												<p className="floatRight">
													<input type="submit" className="blueButton uppercase" defaultValue="Submit" />
												</p>
												<p className="floatLeft">
													<input type="button" onClick={this.showForm.bind(this, false)} className="blueButton uppercase" defaultValue="Cancel" />
												</p>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</form>
					}
				</div>}
				{this.state.showReturnGreaterThan15OverlayDialog?<ReturnGreaterThan15OverlayDialog handleClickHere={this.handleClickHere.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showRequestReturnOnlyAccessoriesSelectedOverlayDialog?<RequestReturnOnlyAccessoriesSelectedOverlayDialog callBackContinue={this.callBackContinue.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestReturnDetails: (data) => dispatch(setRequestReturnDetails(data)),
	savePreviousReturnAndCreditDetails: (data) => dispatch(savePreviousReturnAndCreditDetails(data)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	saveRequestReturnPimData: (requestReturnPimdata) => dispatch(saveRequestReturnPimData(requestReturnPimdata)),
});

RequestReturnStep1 = connect(mapStateToProps, mapDispatchToProps)(RequestReturnStep1);
export default RequestReturnStep1;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/requestReturnStep1.js